// Bảng tên icon (server trả) → FontAwesome; dùng chung cho danh sách + modal nhiệm vụ.
import { faBagShopping, faBolt, faClock, faEye, faFire, faGift, faNewspaper, faStar, faTag, faUsers } from "@fortawesome/free-solid-svg-icons";

export const MISSION_ICON_MAP = {
    eye: faEye, clock: faClock, bag: faBagShopping, users: faUsers, fire: faFire,
    gift: faGift, star: faStar, bolt: faBolt, tag: faTag, newspaper: faNewspaper,
};
export const missionIcon = (name) => MISSION_ICON_MAP[name] || faStar;
